module.exports = __webpack_public_path__ + "img/right-arrow.b2a0f548.png";